import { createUserNewsletterModel } from "@/forms/form-types/user-model";
import { normalizeFields } from "@/forms/helpers";

export function createFormFields(defaultNewsletter: UserNewsletterVM) {
  const model = {
    ...(!defaultNewsletter.isSignedUp ? createUserNewsletterModel(true) : {}),
  };

  return normalizeFields(model);
}
